const heelHeightGroups: { [key: string]: { [key: string]: string } } = {
  flat: {
    'en-us': '0-1"',
    default: '0-2cm',
  },
  low: {
    'en-us': '1-1 \u00BE"',
    default: '2-4cm',
  },
  medium: {
    'en-us': '2-2 \u00BE"',
    default: '4-7cm',
  },
  high: {
    'en-us': '3-3 \u00BE"',
    default: '7-13cm',
  },
};

export const getHeelHeightGroupValue = (locale: string, label: string) =>
  heelHeightGroups[label][locale] || heelHeightGroups[label].default;
